module.exports = __webpack_public_path__ + "img/ciphertext_symbols.24e34402.png";